export default __webpack_public_path__ + "static/bannerAdBooks-d5761c1d1279d81defb06933d5651467.png";